import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { Box, Flex, Image, Text } from "@chakra-ui/react";

import MenuOpcoesAuditoria, { ItemVisualizar } from "../MenuOpcoesAuditoria";
import {
  Permission,
  criancaFunc,
  servicoAcolhimentoFunc,
} from "../../../helpers/Funcionalidades";
import { useAuthProvider } from "../../../Context/AuthProvider";

export default function AuditoriaDetalheHeader({
  imagem,
  titulo,
  subtitulos,
  visao,
  id,
  filtrosOrigem,
}) {
  const history = useHistory();
  const { roleKeycloack } = useAuthProvider();
  const [erro, setErro] = useState(false);

  useEffect(() => {
    setErro(false);
  }, [imagem]);

  return (
    <Flex
      w="100%"
      backgroundColor="#FFF"
      borderRadius="10px"
      p="18px 24px"
      alignItems="flex-start"
      justifyContent="space-between"
      gap={4}
    >
      <Flex alignItems="center" gap={4}>
        {imagem && !erro ? (
          <Image
            borderRadius="full"
            boxSize="56px"
            objectFit="cover"
            src={imagem}
            onError={() => setErro(true)}
          />
        ) : (
          <Box boxSize="56px" bgColor="#C4C4C4" borderRadius="full" />
        )}
        <Flex flexDir="column">
          <Text fontWeight={700} fontSize="18px" color="#252733">
            {titulo}
          </Text>
          {subtitulos
            ?.filter((linha) => !!linha)
            .map((linha, i) => (
              <Text key={i} fontSize="12px" color="#6B6C71">
                {linha}
              </Text>
            ))}
        </Flex>
      </Flex>

      <MenuOpcoesAuditoria
        visao={visao}
        id={id}
        filtrosOrigem={filtrosOrigem}
        boxSize="38px"
        visualizar={
          <Permission
            roleKeycloack={roleKeycloack}
            func={
              visao === "SERVICO"
                ? servicoAcolhimentoFunc.visualizar
                : criancaFunc.visualizar
            }
          >
            <ItemVisualizar
              onClick={() =>
                history.push(
                  visao === "SERVICO"
                    ? `/servico-acolhimento/${id}`
                    : `/crianca/${id}`,
                )
              }
            />
          </Permission>
        }
      />
    </Flex>
  );
}
